<template>
    <div class="product-card birthday-posters-card">
        <div class="product-card__content">
            <div class="product-card__title" style="margin-left: 10px">
                <h5>Birthday Posters</h5>
            </div>

            <div class="birthday-posters-container">
                <div class="birthday-posters">
                    <table class="w-full">
                        <thead>
                            <tr>
                                <th style="width: 250px">Name</th>
                                <th style="width: 176px">Date</th>
                                <th style="width: 60px"></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr
                                v-for="(item, i) in posters"
                                :key="`poster-${i}`"
                            >
                                <td style="vertical-align: top">
                                    <div
                                        class="input-wrapper"
                                        :class="{
                                            'has-error': veeErrors.has(
                                                `name-${i}`
                                            )
                                        }"
                                    >
                                        <el-input
                                            :name="`name-${i}`"
                                            @change="onChange"
                                            autocomplete="off"
                                            class="w-full"
                                            data-vv-as="name"
                                            v-model="item.name"
                                            v-validate="'required'"
                                        />
                                        <span
                                            class="error-text"
                                            v-if="veeErrors.has(`name-${i}`)"
                                        >
                                            Name is required.
                                        </span>
                                    </div>
                                </td>
                                <td style="vertical-align: top">
                                    <div
                                        class="input-wrapper"
                                        :class="{
                                            'has-error': veeErrors.has(
                                                `birth_date-${i}`
                                            )
                                        }"
                                    >
                                        <el-date-picker
                                            :name="`birth_date-${i}`"
                                            @change="onChange"
                                            class="w-full"
                                            data-vv-as="birth date"
                                            v-model="item.birth_date"
                                            v-validate="'required'"
                                            :default-value="defaultDate"
                                            :picker-options="pickerOptions"
                                            format="MM-dd"
                                            value-format="yyyy-MM-dd"
                                        />
                                        <span
                                            class="error-text"
                                            v-if="
                                                veeErrors.has(`birth_date-${i}`)
                                            "
                                        >
                                            Birth date is required.
                                        </span>
                                    </div>
                                </td>
                                <td class="pt-10" style="vertical-align: top">
                                    <el-button
                                        size="small"
                                        type="danger"
                                        icon="mdi mdi-delete"
                                        @click="removeItem(item)"
                                    ></el-button>
                                </td>
                            </tr>
                            <tr>
                                <td class="pt-10" colspan="3">
                                    <el-button
                                        @click="addItem()"
                                        icon="mdi mdi-plus"
                                        round
                                        size="small"
                                        type="primary"
                                    >
                                        Add
                                    </el-button>
                                    <el-button
                                        :loading="saving"
                                        @click="save()"
                                        icon="mdi mdi-content-save"
                                        round
                                        v-if="hasChanges"
                                        size="small"
                                        type="success"
                                    >
                                        Save Changes
                                    </el-button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="birthday-posters-preview">
                    <img
                        src="/images/order/birthday-posters.png"
                        class="w-full"
                        alt="Birthday Posters Preview"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
function newItem() {
    return {
        name: null,
        birth_date: null
    };
}

export default {
    props: {
        posters: {
            type: Array,
            default() {
                return [];
            }
        },
        saving: {
            type: Boolean,
            default: false
        },
        year: {
            type: Number,
            required: true
        },
        month: {
            type: Number,
            required: true
        }
    },
    data() {
        let self = this;
        return {
            oldData: null,
            pickerOptions: {
                disabledDate(date) {
                    let moment_date = moment(date);
                    return !(
                        moment_date.year() === self.year &&
                        moment_date.month() + 1 === self.month
                    );
                }
            }
        };
    },
    mounted() {
        this.oldData = this.getDataJson();
    },
    computed: {
        hasChanges() {
            return this.oldData !== this.getDataJson();
        },
        defaultDate() {
            return moment([this.year, this.month - 1]);
        }
    },
    methods: {
        getDataJson() {
            return JSON.stringify(
                this.posters.map((item) => _.pick(item, ["name", "birth_date"]))
            );
        },
        addItem() {
            this.posters.push(newItem());
        },
        removeItem(item) {
            Utils.arrayDelete(this.posters, item);
        },
        onChange() {
            this.$emit("change", this.posters);
        },
        save() {
            this.$validator.validate().then((valid) => {
                if (!valid) {
                    return;
                }
                this.$emit("save");
            });
        }
    },
    watch: {
        saving(val) {
            if (!val) {
                this.oldData = this.getDataJson();
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.birthday-posters-card {
    max-width: 1000px !important; // Override the 300px from product-card.scss
    margin-left: 0 !important; // Force left alignment instead of center
    margin-right: auto !important;
}

.birthday-posters-container {
    display: grid;
    grid-template-columns: 1fr 300px;
    gap: 24px;
    align-items: start;
}

.birthday-posters-preview {
    position: sticky;
    top: 24px;
}

.birthday-posters {
    .input-wrapper {
        margin-bottom: 8px;

        &.has-error {
            .el-input__inner,
            .el-date-editor.el-input {
                border-color: #f56c6c;
            }
        }
    }

    .error-text {
        display: block;
        font-size: 12px;
        color: #f56c6c;
        margin-top: 4px;
    }

    table {
        th {
            padding: 12px;
            text-align: left;
            background: #f8f9fa;
            border-bottom: 1px solid #ebeef5;
            font-weight: 500;
        }

        td {
            padding: 12px;
            border-bottom: 1px solid #ebeef5;
        }
    }
}
</style>
